import React, { useState, useEffect } from "react";
import { zoneAPI } from "../utils/zone-api";
import "./AddressForm.css";

export default function AddressForm({ onSubmit, initialData = {}, onCancel }) {
  const [formData, setFormData] = useState({
    first_name: initialData.first_name || "",
    last_name: initialData.last_name || "",
    phone_number: initialData.phone_number || "",
    zone_id: initialData.zone_id || "",
    full_address: initialData.full_address || "",
    more_details: initialData.more_details || "",
  });
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [zonesLoading, setZonesLoading] = useState(true);

  useEffect(() => {
    fetchZones();
  }, []);

  const fetchZones = async () => {
    try {
      const data = await zoneAPI.getZones();
      if (data.success) {
        setZones(data.zones || []);
      }
    } catch (error) {
      console.error("Error fetching zones:", error);
    } finally {
      setZonesLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await onSubmit(formData);
    } catch (error) {
      console.error("Error submitting address:", error);
    } finally {
      setLoading(false);
    }
  };

  const selectedZone = zones.find(zone => zone.id == formData.zone_id);

  return (
    <div className="address-form-container">
      <form onSubmit={handleSubmit} className="address-form">
        <div className="form-header">
          <h3>{initialData.id ? "Edit Address" : "Add New Address"}</h3>
          {onCancel && (
            <button type="button" onClick={onCancel} className="cancel-btn">
              Cancel
            </button>
          )}
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="first_name">First Name *</label>
            <input
              type="text"
              id="first_name"
              name="first_name"
              value={formData.first_name}
              onChange={handleInputChange}
              required
              placeholder="Enter your first name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="last_name">Last Name *</label>
            <input
              type="text"
              id="last_name"
              name="last_name"
              value={formData.last_name}
              onChange={handleInputChange}
              required
              placeholder="Enter your last name"
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="phone_number">Phone Number *</label>
          <input
            type="tel"
            id="phone_number"
            name="phone_number"
            value={formData.phone_number}
            onChange={handleInputChange}
            required
            placeholder="Enter your phone number"
          />
        </div>

        <div className="form-group">
          <label htmlFor="zone_id">Zone *</label>
          {zonesLoading ? (
            <div className="loading-zones">Loading zones...</div>
          ) : (
            <select
              id="zone_id"
              name="zone_id"
              value={formData.zone_id}
              onChange={handleInputChange}
              required
            >
              <option value="">Select a zone</option>
              {zones.map((zone) => (
                <option key={zone.id} value={zone.id}>
                  {zone.name} - ${zone.shipping_price} shipping
                </option>
              ))}
            </select>
          )}
          {selectedZone && (
            <div className="zone-info">
              <span className="zone-shipping">
                Shipping cost: <strong>${selectedZone.shipping_price}</strong>
              </span>
            </div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="full_address">Full Address *</label>
          <textarea
            id="full_address"
            name="full_address"
            value={formData.full_address}
            onChange={handleInputChange}
            required
            rows="3"
            placeholder="Enter your complete address including street, building, floor, etc."
          />
        </div>

        <div className="form-group">
          <label htmlFor="more_details">Additional Details</label>
          <textarea
            id="more_details"
            name="more_details"
            value={formData.more_details}
            onChange={handleInputChange}
            rows="2"
            placeholder="Any additional information (landmarks, directions, etc.)"
          />
          <small className="form-help">
            Optional: Add any helpful details for delivery
          </small>
        </div>

        <div className="form-actions">
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? (
              <>
                <div className="spinner"></div>
                {initialData.id ? "Updating..." : "Saving..."}
              </>
            ) : (
              initialData.id ? "Update Address" : "Save Address"
            )}
          </button>
        </div>
      </form>
    </div>
  );
}
